export default "__VITE_ASSET__ImpNNT5Q__"